import React, { createContext, FC, PropsWithChildren, useState } from "react";

export interface CoordinatesListProps {
  [key: string]: string;
}

export interface CurrentProps {
  title: string;
  latitude: string;
  longitude: string;
}

export interface CoordinatesContextProps {
  coordinatesList: CoordinatesListProps;
  currentCoordinates: ({ title, latitude, longitude }: CurrentProps) => void;
}

export const GetCoordinatesContext =
  createContext<CoordinatesContextProps | null>(null);

const GetCoordinatesProvider: FC<PropsWithChildren<React.ReactNode>> = ({
  children,
}) => {
  const [coordinatesList, setCoordinatesList] =
    useState<CoordinatesListProps | null>({});

  const currentCoordinates = ({ title, latitude, longitude }: CurrentProps) => {
    setCoordinatesList((value) => {
      return {
        ...value,
        [title + "latitude"]: latitude,
        [title + "longitude"]: longitude,
      };
    });
  };

  return (
    <GetCoordinatesContext.Provider
      value={{ coordinatesList, currentCoordinates }}
    >
      {children}
    </GetCoordinatesContext.Provider>
  );
};

export default GetCoordinatesProvider;
